import { useQuery } from "@tanstack/react-query";
import Client from "../api/client";
import { ArticleCard } from "./article-card";
import { Box, Skeleton, SkeletonText, Stack } from "@chakra-ui/react";

export const ArticleList = () => {
  const { data: articles, isLoading } = useQuery({
    queryKey: ["articles"],
    queryFn: async () => {
      const tempArticleData = await Client.getArticles();

      return tempArticleData;
    },
  });

  if (isLoading) {
    return (
      <Stack paddingTop={"2rem"}>
        <Skeleton height="20px" startColor="hn.background_dark" />
        <br></br>
        <SkeletonText
          startColor="hn.background_dark"
          noOfLines={4}
          spacing="4"
        />
      </Stack>
    );
  }

  return (
    <Box>
      {articles?.map((articleData: any) => (
        <ArticleCard key={articleData.id} articleData={articleData} />
      ))}
    </Box>
  );
};
